<template>
    <div>
        <div class="inline-form-group">
            <el-form-item label="Wymagane"
                          :error="errors['required']">
                <el-switch v-model="form['required']"/>
            </el-form-item>
            <el-form-item label="Pole od krawędzi do krawędzi"
                          :error="errors.full_width">
                <el-switch v-model="form.full_width"/>
            </el-form-item>
        </div>
        <div class="inline-form-group">
            <el-form-item label="Nazwa pola"
                          :error="errors[addLanguageSuffix('label')]"
                          required>
                <el-input v-model="form[addLanguageSuffix('label')]"
                          type="textarea"
                          placeholder="Nazwa pola"/>
            </el-form-item>
            <el-form-item label="Placeholder"
                          :error="errors[addLanguageSuffix('placeholder')]">
                <el-input v-model="form[addLanguageSuffix('placeholder')]"
                          placeholder="Placeholder"/>
            </el-form-item>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// BaseField.vue?75586753